import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const FilterContainer = styled.div`
    padding-bottom: 0.8rem;
    margin-bottom: 0.8rem;
    border-bottom: 1px solid #fff;

    h4 {
        margin-bottom: 0;
    }

    .filter-inputs {
        height: 0px;
        overflow: hidden;

        &.filter-inputs--show {
            height: auto;
            overflow: visible;
            margin-top: 1rem;
        }
    }
`

export const FilterHeader = styled.div`
    cursor: pointer;
    user-select: none;

    h4 {
        font-size: 1rem;
        margin-bottom: 0;
    }

    .filter-count {
        color: ${props => props.theme.admin.colors.brand};
        font-size: 0.9rem;
        font-weight: 300;
    }
`

export const Filters = styled.div`
    position: relative;
`

export const FiltersButton = styled.button`
    width: 90px;
`

export const FiltersList = styled.div`
    position: absolute;
    top: calc(100% + 5px);
    right: 0;
    background-color: #ffffff;
    min-width: 100%;
    max-height: 300px;
    overflow: auto;
    padding: 5px;
    box-shadow: 0 0 3px 0px #c5c5c5;
    border-radius: 4px;
    z-index: 10;
    width: 180px;
`

export const FiltersOption = styled.div`
    label {
        cursor: pointer;
        user-select: none;
        width: 100%;
    }

    &:last-child {
        label {
            margin-bottom: 0;
        }
    }
`

export const FilterManagement = styled.div`
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    width: 100%;

    ${breakpoint('laptop')`
       width: auto;  
    `};
`
